import i18n from "../../../i18n";

const TITLE_DICT = {
  my_home: { label: "MY HOME", navigateTo: "/" },
  investments: { label: i18n.t("headers.investments") },
  owners: { label: i18n.t("headers.owners") },
  bom_styles_configurator: { label: i18n.t("headers.bom_styles_configurator") },
  bom_configurator: { label: i18n.t("headers.bom_configurator") },
  bom_standard_configurator: {
    label: i18n.t("headers.bom_standard_configurator"),
  },
  bom_materials_services_configurator: {
    label: i18n.t("headers.bom_materials_services_configurator"),
  },
  bom_pricing_configurator: {
    label: i18n.t("headers.bom_pricing_configurator"),
  },
  object_list: { label: i18n.t("headers.object_list") },
  item_tree: { label: i18n.t("headers.item_tree") },
  item_registry: { label: i18n.t("headers.item_registry") },
  material_passport: { label: i18n.t("headers.material_passport") },
  items: { label: i18n.t("headers.items") },
  materials: { label: i18n.t("headers.materials") },
  services: { label: i18n.t("headers.services") },
  equipments: { label: i18n.t("headers.equipments") },
  wbs_kind_subkind_admin: { label: i18n.t("headers.wbs_kind_subkind_admin") },
  warehouse_admin: { label: i18n.t("headers.warehouse_admin") },
  warehouses: { label: i18n.t("headers.warehouses") },
  admin_users: { label: i18n.t("headers.admin_users") },
};

export default TITLE_DICT;
